/**
 * Constants.ts
 */
export class Constants {
}
Constants.PROPERTY_USER_ID = "userId";
Constants.PROPERTY_LAST_LOGIN_DATE = "lastLoginDate";
Constants.PROPERTY_ACCESS_TOKEN = "access_token";
Constants.PROPERTY_TOKEN = "token";
Constants.PROPERTY_TYPE_SHORT = "t";
Constants.PROPERTY_AMOUNT_SHORT = "amt";
Constants.PROPERTY_NODE_NAME = "nodeName";
Constants.PROPERTY_SOCKET_PORT = "socketPort";
Constants.PROPERTY_HTTP_PORT = "httpPort";
Constants.PROPERTY_WEB_SOCKET_PORT = "websocketPort";
Constants.PROPERTY_USERNAME = "username";
Constants.PROPERTY_ACCOUNT_BALANCE = "accountBalance";
Constants.PROPERTY_BALANCE = "balance";
Constants.PROPERTY_CURRENCY_CODE_SHORT = "cc";
Constants.PROPERTY_NEEDS_TO_ACCEPT_TC = "needsToAcceptTC";
Constants.PROPERTY_MESSAGE_ACKNOWLEDGED = "msgAcknowledged";
Constants.PROPERTY_ACTIVE_BALANCE = "activeBalance";
Constants.PROPERTY_POST_WAGER = "isPostWager";
Constants.PROPERTY_WIN_PROCESSOR_RSP = "winProcessorRsp";
Constants.PROPERTY_CURRENT_TIME = "currentTime";
Constants.PROPERTY_TIME_ZONE = "timeZone";
Constants.PROPERTY_TYPE = "type";
Constants.PROPERTY_AMOUNT = "amount";
Constants.PROPERTY_CURRENCY_CODE = "currencyCode";
Constants.PROPERTY_FREEROUNDS_UUID = "playFreeRoundUuid";
export class ResultCode {
}
ResultCode.SUCCESS = 0;
ResultCode.FAILED = 1;
ResultCode.PROPERTY_VALUE_ERROR = 2;
ResultCode.USER_NOT_FOUND = 4;
ResultCode.USER_NOT_AUTHENTICATED = 5;
ResultCode.GAME_NOT_EXIST = 13;
ResultCode.INSUFFICIENT_FUNDS = 14;
ResultCode.GAME_TICKETS_NOT_AVAILABLE = 15;
ResultCode.MAX_TICKETS_EXCEEDED = 16;
ResultCode.GAME_NOT_TAKING_BETS = 17;
ResultCode.GAME_NOT_IN_PROGRESS = 18;
ResultCode.RESTRICTED_TERRITORY = 19;
ResultCode.INSUFFICIENT_BALANCE = 22;
ResultCode.USER_ALREADY_REGISTERED = 23;
ResultCode.VALUE_TAKEN = 24;
ResultCode.USERNAME_TAKEN = 24;
ResultCode.EMAIL_TAKEN = 25;
ResultCode.GAME_ACCESS_DENIED = 26;
ResultCode.ITEM_ALREADY_CLAIMED = 27;
ResultCode.INVALID_JACKPOT_CALL = 28;
ResultCode.INVALID_TOKEN = 30;
ResultCode.MIN_TICKETS_NOT_MET = 31;
ResultCode.CHAT_NAME_TAKEN = 32;
ResultCode.CHAT_NAME_INVALID = 33;
ResultCode.NO_TICKETS_HELD = 34;
ResultCode.UNKNOWN_PROMOTION_CODE = 35;
ResultCode.MINIMUM_NOT_MET = 36;
ResultCode.MAXIMUM_LIMIT_MET = 38;
ResultCode.INVALID_REQUEST_TYPE = 39;
ResultCode.MYSTERY_GIFT_ALREADY_GIFTED_USER = 40;
ResultCode.MYSTERY_GIFT_SENDING_MORE_THAN_ALLOWED = 41;
ResultCode.MYSTERY_GIFT_CLAIMING_MORE_THAN_ALLOWED = 42;
ResultCode.NO_USER_SAFE = 43;
ResultCode.SAFE_NOT_UNLOCKED = 44;
ResultCode.SAFE_KEY_LINK_ALREADY_CREATED = 45;
ResultCode.INVALID_EXTERNAL_UID = 46;
ResultCode.ROOM_FULL = 47;
ResultCode.PROMOTION_CLAIM_LIMIT_EXCEEDED = 48;
ResultCode.GAME_ROOM_INSTANCE_NOT_EXIST = 49;
ResultCode.ALREADY_PROCESSED = 50;
ResultCode.INVALID_GAME_TYPE = 51;
ResultCode.LINK_GENERATE_NOT_ALLOWED = 52;
ResultCode.REGULATORY_MESSAGE = 56;
ResultCode.WAGER_BONUS_MESSAGE = 57;
ResultCode.WAGER_CASH_MESSAGE = 58;
ResultCode.OUT_OF_DATE_VERSION = 61;
ResultCode.POWER_PLAY_LIMIT_EXCEEDED = 65;
ResultCode.USER_EXCLUDED = 66;
ResultCode.NO_DEPOSIT_GAME_FOR_USER = 67;
ResultCode.INVALID_DEPOSIT_ID = 68;
ResultCode.DEPOSIT_GAME_ALREADY_PLAYED = 69;
ResultCode.MAX_WIN_EXCEEDED = 70;
ResultCode.INVALID_CARD = 71;
ResultCode.VALIDATION_FAILED = 72;
ResultCode.DEPOSIT_FAILED = 73;
ResultCode.DUPLICATE_CARD = 74;
ResultCode.DEPOSIT_LIMIT_SUPPORT = 77;
ResultCode.DEPOSIT_LIMIT_COOL_OFF = 78;
ResultCode.NO_USER_DEPOSIT = 83;
ResultCode.BONUS_GAME_REDEEMED = 84;
ResultCode.BONUS_WIN_AMOUNT_EXCEEDED = 89;
ResultCode.BONUS_CODE_MAX_REDEMPTION_PER_DATE = 90;
ResultCode.BONUS_CODE_MAX_REDEMPTION_PER_PROMO = 91;
ResultCode.BONUS_CODE_MAX_REDEMPTIONS = 92;
ResultCode.BONUS_CODE_NOT_AVAILABLE_YET = 93;
ResultCode.BONUS_CODE_NOT_FOUND = 94;
ResultCode.MAX_BET_EXCEEDED = 142;
ResultCode.MAX_TRADE_EXCEEDED = 143;
ResultCode.ACCOUNT_LIMIT_EXCEEDED = 150;
ResultCode.CURRENCY_NOT_SUPPORTED = 151;
ResultCode.RESPONSIBLE_GAMING_TIME_LIMIT_MESSAGE = 157;
ResultCode.ACCOUNT_LIMIT_EXCEEDED_GENERIC = 159;
ResultCode.JACKPOT_ALREADY_WON = 160;
ResultCode.RETRIABLE_WIN_OCCURRED = 161;
ResultCode.RESPONSIBLE_GAMING_TURNOVER_LIMIT = 162;
ResultCode.OPERATOR_ERROR = 163;
export class CurrencyCode {
}
CurrencyCode.GBP = "GBP";
export class CurrencyType {
}
CurrencyType.NONE = "NONE";
CurrencyType.CASH = "CASH";
CurrencyType.BONUS = "BONUS";
export class DeviceType {
}
DeviceType.MOBILE = "MOBILE";
DeviceType.DESKTOP = "DESKTOP_WEB";
DeviceType.MOBILE_WEB = "MOBILE_WEB";
//# sourceMappingURL=Constants.js.map